import React, { useEffect, useState } from "react";
import {
  PartialDentureForm,
  PartialDentureProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputNew";
import SelectInput from "../formComp/SelectInputNew";
import ToothField from "../formComp/ToothField";

const PartialDenture: React.FC<PartialDentureProps> = ({ onChange }) => {
  const [form, setForm] = useState<PartialDentureForm>({
    teethReplaced: [],
    teethExtracted: [],
    desiredOutput: "",
    finishedProduct: "",
    modelNeeded: "",
    additionalNotes: "",
    shade: "",
  });

  const handleToothClick = (
    type: "teethReplaced" | "teethExtracted",
    tooth: number
  ) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof PartialDentureForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-[var(--cu-text)]">
      <div className="mb-3 border-b border-[var(--cu-border)] pb-2">
        <h2 className="text-sm font-medium text-[var(--cu-accent)]">
          LDP Partial Denture
        </h2>
      </div>

      <div className="w-full space-y-3">
        <ToothField
          label="Teeth to be replaced"
          toothNumbers={form.teethReplaced}
          onToothClick={(tooth) => handleToothClick("teethReplaced", tooth)}
        />

        <ToothField
          label="Teeth to be extracted"
          optional
          toothNumbers={form.teethExtracted}
          onToothClick={(tooth) => handleToothClick("teethExtracted", tooth)}
        />

        {/* Desired output */}
        <SelectInput
          label="Desired output"
          name="desiredOutput"
          value={form.desiredOutput}
          onChange={(e) => handleChange("desiredOutput", e.target.value)}
          options={[
            { value: "Monoblock", label: "Monoblock" },
            {
              value: "Separate gingiva and teeth",
              label: "Separate gingiva and teeth",
            },
            {
              value: "both",
              label: "Both",
            },
          ]}
        />

        {/* Finished product */}
        <SelectInput
          optional
          label="Finished product"
          name="finishedProduct"
          value={form.finishedProduct}
          onChange={(e) => handleChange("finishedProduct", e.target.value)}
          options={[
            { value: "Print only", label: "Print only" },
            { value: "Print, fuse & cure", label: "Print, fuse & cure" },
            {
              value: "Print, fuse, cure & finish",
              label: "Print, fuse, cure & finish",
            },
          ]}
        />

        {/* Is 3D model needed? */}
        <SelectInput
          optional
          label="Is 3D model needed?"
          name="modelNeeded"
          value={form.finishedProduct}
          onChange={(e) => handleChange("modelNeeded", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        {/* Shade */}
        <TextInput
          optional
          label="Shade"
          name="shade"
          value={form.shade}
          onChange={(e) => handleChange("shade", e.target.value)}
        />

        {/* Additional notes */}
        <TextInput
          optional
          label="Additional notes"
          name="additionalNotes"
          value={form.additionalNotes}
          onChange={(e) => handleChange("additionalNotes", e.target.value)}
        />
      </div>
    </div>
  );
};

export default PartialDenture;
